import { render, staticRenderFns } from "./vconsoleSwitch.vue?vue&type=template&id=035e932a&scoped=true"
import script from "./vconsoleSwitch.vue?vue&type=script&lang=js"
export * from "./vconsoleSwitch.vue?vue&type=script&lang=js"
import style0 from "./vconsoleSwitch.vue?vue&type=style&index=0&id=035e932a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035e932a",
  null
  
)

export default component.exports